import { render, staticRenderFns } from "./invoice_confirmation.vue?vue&type=template&id=5b5c72bf&"
import script from "./invoice_confirmation.vue?vue&type=script&lang=js&"
export * from "./invoice_confirmation.vue?vue&type=script&lang=js&"
import style0 from "./invoice_confirmation.vue?vue&type=style&index=0&id=5b5c72bf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports